// extracted by mini-css-extract-plugin
export var actionButton = "_qw-0";
export var actionMenuContainer = "_qw-i";
export var bubble = "_qw-2";
export var bubbleActionMenu = "_qw-j";
export var bubbleContext = "_qw-6";
export var bubbleItems = "_qw-7";
export var customer = "_qw-3";
export var divider = "_qw-8";
export var fileList = "_qw-9";
export var hiddenComment = "_qw-o";
export var infoAbove = "_qw-a";
export var internal = "_qw-4";
export var lightActionButton = "_qw-1";
export var link = "_qw-b";
export var merchant = "_qw-5";
export var message = "_qw-c";
export var profilePicture = "_qw-e";
export var quillToolbarContainer = "_qw-f";
export var senderDate = "_qw-g";
export var senderDateCustomer = "_qw-h";
export var senderName = "_qw-d";
export var time = "_qw-k";
export var uploadedImage = "_qw-l";
export var username = "_qw-m";
export var xsmall = "_qw-n";